import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const CLASSES_SIDEBAR_DATA = [
  {
    header: 'SCHEDULE',
    tabs: [
      {
        tabName: 'View Schedule',
        to: '/classes/view-schedule',
        subject: PERMISSION_SUBJECTS.sbatGroup,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
      {
        tabName: 'Schedule Classes',
        to: '/classes/schedule-classes',
        subject: PERMISSION_SUBJECTS.sbatGroup,
        permissions: [PERMISSION_ACTIONS.create, PERMISSION_ACTIONS.manage],
      },
    ],
  },
  {
    header: 'LIBRARY',
    tabs: [
      {
        tabName: 'Create Library',
        to: '/classes/create-library',
        subject: PERMISSION_SUBJECTS.library,
        permissions: [PERMISSION_ACTIONS.create, PERMISSION_ACTIONS.manage],
      },
      {
        tabName: 'Edit Libraries',
        to: '/classes/edit-library',
        subject: PERMISSION_SUBJECTS.library,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
  {
    header: 'BATCH',
    tabs: [
      {
        tabName: 'Edit Batches',
        to: '/classes/edit-super-batch',
        subject: PERMISSION_SUBJECTS.superBatch,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
  {
    header: 'CLASS',
    tabs: [
      {
        tabName: 'Create Class',
        to: '/classes/create-class',
        subject: PERMISSION_SUBJECTS.academyTopic,
        permissions: [PERMISSION_ACTIONS.create, PERMISSION_ACTIONS.manage],
      },
      {
        tabName: 'Edit Classes',
        to: '/classes/edit-classes',
        subject: PERMISSION_SUBJECTS.academyTopic,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];

export default CLASSES_SIDEBAR_DATA;
